import React from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "./button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./command";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { cn } from "../../lib/utils";
import { getProducts } from "../../features/product/api/getProducts";
import { useNavigate } from "react-router-dom";

export function ComboboxDemo() {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState("");
  const [products, setProducts] = React.useState<any[]>([]);
  const [filteredProducts, setFilteredProducts] = React.useState<any[]>([]);
  const navigate = useNavigate();

  const handleProduct = async () => {
    try {
      const response = await getProducts();
      const activeProducts = response.data.products.filter(
        (product: { is_active: number }) => product.is_active === 1
      );
      setProducts(activeProducts);
      setFilteredProducts(activeProducts);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleSearch = (query: string) => {
    if (!query.trim()) {
      setFilteredProducts(products);
      return;
    }

    const searchQuery = query.toLowerCase().trim();

    const filtered = products.filter((product: any) => {
      const nameAr = (product.name_ar || "").toLowerCase();
      return nameAr.includes(searchQuery);
    });

    setFilteredProducts(filtered);
  };

  React.useEffect(() => {
    handleProduct();
  }, []);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="justify-between md:w-96 w-full"
        >
          {value
            ? products.find((product: any) => product.name_ar === value)
                ?.name_ar || "عنصر غير موجود"
            : "البحث عن عنصر"}
          <ChevronsUpDown className="ml-2 h-4 w-10 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="md:w-96 w-full p-0">
        <Command className="w-full">
          <CommandInput
            placeholder="...البحث عن عنصر"
            className="h-9"
            onValueChange={handleSearch}
            dir="rtl"
          />
          <CommandList>
            {filteredProducts.length > 0 ? (
              <CommandGroup>
                {filteredProducts.map((product: any) => (
                  <CommandItem
                    className="text-right flex justify-end cursor-pointer"
                    key={product.id}
                    value={product.name_ar} // Changed to use name_ar instead of id
                    onSelect={(currentValue) => {
                      setValue(currentValue);
                      // Find the product ID based on the selected name_ar
                      const selectedProduct = products.find(
                        (p) => p.name_ar === currentValue
                      );
                      if (selectedProduct) {
                        console.log("selectedProduct", selectedProduct);

                        navigate(
                          `/home/${selectedProduct.category.id}/${selectedProduct.id}`
                        );
                      }
                      setOpen(false);
                    }}
                  >
                    <div className="text-right">{product.name_ar}</div>
                  </CommandItem>
                ))}
              </CommandGroup>
            ) : (
              <CommandEmpty>لايوجد اي عنصر</CommandEmpty>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
